import Model from '@/models/Model';
import api from '@/services/Api';

export default class TimeRegistration extends Model {
    get route () {
        return 'time-registrations';
    }

    static get className () {
        return 'TimeRegistration';
    }

    static open (query) {
        query = this.makeQuery(query);
        query = query ? `?${query}` : query;
        return api.get(`${this.route}/open${query}`);
    }
}
